import { ROUTES } from "../../../../api/api.routes";
import useCustomQuery from "../../../../hooks/useQuery";
import { Sorted } from "../../../../types/db/collections";
import { GhlTag } from "../../../../types/services/ghl/ghl.tags.schema";

export const useGhlTags = () => {
  const { data, isLoading, mutate } = useCustomQuery<Sorted<GhlTag>>(ROUTES.Services.GHL.Tags.All);

  return {
    tags: data?.items ?? [],
    tagsById: data?.byId ?? {},
    isLoading,
    mutate
  }
}